// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6FVYK","header__hero-text":"Header_header__hero-text__7Bf7W","header__descr":"Header_header__descr__cmCEP"};